<template>
    <div class="visor-pdf" v-loading="loading">
        
        <div v-if="error"  class="empty">
            <img src="../../assets/Error.png">
            <p>Ha ocurrido un error al mostrar el PDF</p>
        </div>

        <div v-else-if="file" class="visor-pdf-content">
            <vue-pdf-app :config="config" :pdf="base64ToArrayBuffer(file)" :file-name="name"></vue-pdf-app>
            <div class="firmar">
                <el-button slot="append" type="danger" @click="confirmRechazarFirma()">Rechazar</el-button>

                <el-input placeholder="Introduce una contraseña para firmar" v-model="password" show-password></el-input>

                <div class="firmar-acciones">
                    <el-dropdown split-button type="default" @click="switchFirmar()" @command="handleCommandFirmarAcciones">
                        Firmar
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="firmarDescargar">Firmar y descargar</el-dropdown-item>
                            <!--<el-dropdown-item command="firmarImage">Firmar con imagen</el-dropdown-item>-->
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                
            </div>
        </div>
        
        <div v-else class="empty">
            <img src="../../assets/NoSearchResult.png">
            <p>Selecciona un documento para visualizarlo</p>
        </div>

        <!-- Modal para firmar con imagen -->
        <el-dialog
            class="dialog-firma"
            title="Firmar"
            :visible.sync="showFirmaImage.open"
            append-to-body
            :close-on-click-modal="!loading"
            :close-on-press-escape="!loading"
            :show-close="!loading"
            width="800px">

            <PorletVisorPDFFirmarImage 
                v-if="showFirmaImage.open && file" 
                :data="file"
                :id="pdf_id"
                :loadingFirma="loading"
                @cancel="showFirmaImage.open = false"
                @firmar="firmar"/>

        </el-dialog>

    </div>
</template>

<script>
    import Vue from 'vue'

    import {
		getDocumentoPDF,
        postActionData
    } from '@/helpers/api'

    import VuePdfApp from "vue-pdf-app";
    import "vue-pdf-app/dist/icons/main.css";

    import PorletVisorPDFFirmarImage from './PorletVisorPDFFirmarImage.vue'

	export default {
        name: 'VisorPDF',
        props: ['id','porlet'],
        components: {
            VuePdfApp,
            PorletVisorPDFFirmarImage
        },
        data() {
            return {
                error: null,
                loading: false,

                activeTab: 'page_1',
				scale: 100,
				marks: {
					100: {
						style: {
							color: '#1989FA'
						},
						label: this.$createElement('strong', '100%')
					}
				},
                tipo_firma: 1,

                // Gestion archivo
				pdf: null,
				file: null,
                name: '',
				pages: [],
				pdfjsLib: null,
				contentfile: null,

                // Firmar documento
                pdf_id: '', // ID pdf seleccionado
                password: '',

                // Configuracion pdf
                config: {
                    toolbar: {
                        toolbarViewerRight: {
                            openFile: false,
                            viewBookmark: false
                        }
                    }
                },

                // Modal firma con imagen
                showFirmaImage: {
                    open: false,
                    loading: false
                }

            }
        }, 
        mounted() {

            this.getData()

            this.$emit('created')
        },
        methods: {
            async getData(pdf) {
                
                this.error = false

                if(!pdf && !this.id) return

                this.pdf_id = pdf || this.id

                this.loading = true

                try {

                    let formData = new FormData();

                    formData.append('tipo', 'ptes');
                    formData.append('id', this.pdf_id);

                    let resp = await getDocumentoPDF(formData)
                    
                    this.file = resp.data.data.file
                    this.name = resp.data.data.name
                    this.tipo_firma = resp.data.data.tipo_firma

                } catch(e) {
                    this.error = e
                }

                this.loading = false
                
            },
            base64ToArrayBuffer(base64) {
                var binary_string = window.atob(base64);
                var len = binary_string.length;
                var bytes = new Uint8Array(len);
                for (var i = 0; i < len; i++) {
                    bytes[i] = binary_string.charCodeAt(i);
                }
                return bytes.buffer;
            },
            
            // Acciones en funcion del tipo_firma
            switchFirmar() {

                
                // 1,2 Firma normal
                if(["1","2"].includes(this.tipo_firma)) {

                    this.firmar()

                } else { 
                    
                    // 3 firma visible seleccionable
                    this.firmarImage()
                }
            },

            // Firmar documento
            async firmar(options) {

                this.loading = true

                try {

                    let formData = new FormData()

                    formData.append('id', this.pdf_id)
                    formData.append('password', this.password || '')
                    if (options) {
                        let {size, top, left, page} = options
                        
                        formData.append('size', size)
                        formData.append('top', top)
                        formData.append('left', left)
                        formData.append('page', page)
                    }

                    let resp = await postActionData('firmar.php', formData, 'post')

                    if (resp && resp.data && resp.data.recargarComponentes && resp.data.recargarComponentes.length) {
                        resp.data.recargarComponentes.forEach(comp => {
                            this.$referencias[comp].refresh()
                        })
                    }

                    if (resp && resp.data && resp.data.mensajes && resp.data.mensajes.length) {
                        resp.data.mensajes.filter(f => f['message-type'] !== 'Alert').forEach(mensaje => {
                            setTimeout(() => {
                                this.$notify({
                                    title: mensaje.title,
                                    message: mensaje.message,
                                    type: mensaje.type,
                                    position: mensaje.position
                                });
                            }, 5)
                        })
                    }

                    this.resetarFile()

                    this.showFirmaImage.open = false

                } catch (e) {
                    
                    //console.log('Error init :: ',e.response.data)
                    
                    if (e.response && e.response.data && e.response.data.mensajes) {

                        e.response.data.mensajes.filter(f => f['message-type'] !== 'Alert').forEach(mensaje => {
                            setTimeout(() => {
                                this.$notify({
                                    title: mensaje.title,
                                    message: mensaje.message,
                                    type: mensaje.type,
                                    position: mensaje.position
                                });
                            }, 5)
                        })

                    } else {

                        this.$notify.error({
                            title: 'Error',
                            message: 'Ha ocurrido un error'
                        });
                    }
                }

                this.loading = false
                
            },
            async rechazarFirma() {
                this.loading = true

                try {

                    let formData = new FormData()

                    formData.append('id', this.pdf_id)

                    let resp = await postActionData('rechazarFirma.php', formData, 'post')

                    if (resp.data.recargarComponentes && resp.data.recargarComponentes.length) {
                        resp.data.recargarComponentes.forEach(comp => {
                            this.$referencias[comp].refresh()
                        })
                    }

                    if (resp.data.mensajes && resp.data.mensajes.length) {
                        resp.data.mensajes.filter(f => f['message-type'] !== 'Alert').forEach(mensaje => {
                            setTimeout(() => {
                                this.$notify({
                                    title: mensaje.title,
                                    message: mensaje.message,
                                    type: mensaje.type,
                                    position: mensaje.position
                                });
                            }, 5)
                        })
                    }

                    this.resetarFile()

                } catch (e) {
                    
                    console.log('Error init :: ',e.response.data)
                    
                    if (e.response.data && e.response.data.mensajes) {

                        e.response.data.mensajes.filter(f => f['message-type'] !== 'Alert').forEach(mensaje => {
                            setTimeout(() => {
                                this.$notify({
                                    title: mensaje.title,
                                    message: mensaje.message,
                                    type: mensaje.type,
                                    position: mensaje.position
                                });
                            }, 5)
                        })

                    } else {

                        this.$notify.error({
                            title: 'Error',
                            message: 'Ha ocurrido un error'
                        });
                    }
                }

                this.loading = false
            },
            async firmarDescargar() {

                this.loading = true

                try {

                    let formData = new FormData()

                    formData.append('id', this.pdf_id)
                    formData.append('password', this.password || '')

                    let resp = await postActionData('firmar.php', formData, 'post')

                    this.porlet.events.clickAction({
                        url: `/tokenDescarga.php?id=${this.pdf_id}`,
                        auto: true,
                        metodo: 'post'
                    })

                    if (resp.data.recargarComponentes && resp.data.recargarComponentes.length) {
                        resp.data.recargarComponentes.forEach(comp => {
                            this.$referencias[comp].refresh()
                        })
                    }

                    if (resp.data.mensajes && resp.data.mensajes.length) {
                        resp.data.mensajes.filter(f => f['message-type'] !== 'Alert').forEach(mensaje => {
                            setTimeout(() => {
                                this.$notify({
                                    title: mensaje.title,
                                    message: mensaje.message,
                                    type: mensaje.type,
                                    position: mensaje.position
                                });
                            }, 5)
                        })
                    }

                    this.resetarFile()

                } catch (e) {
                    
                    console.log('Error init :: ',e.response.data)
                    
                    if (e.response.data && e.response.data.mensajes) {

                        e.response.data.mensajes.filter(f => f['message-type'] !== 'Alert').forEach(mensaje => {
                            setTimeout(() => {
                                this.$notify({
                                    title: mensaje.title,
                                    message: mensaje.message,
                                    type: mensaje.type,
                                    position: mensaje.position
                                });
                            }, 5)
                        })

                    } else {

                        this.$notify.error({
                            title: 'Error',
                            message: 'Ha ocurrido un error'
                        });
                    }
                }

                this.loading = false
            },
            confirmRechazarFirma() {
                this.$confirm('¿Está seguro de que quiere rechazar la firma?', 'Rechazar firma', {
                    confirmButtonText: 'Rechazar',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'
                }).then(() => {
                    this.rechazarFirma()
                });
            },
            resetarFile() {

                this.file = null
                this.psasword = null

                // Gestion archivo
				this.pdf = null
				this.file = null
                this.name = ''
				this.pages = []
				this.contentfile = null
                this.tipo_firma = 1

                // Firmar documento
                this.pdf_id = ''
                this.password = ''
            },

            // Abrir modal para firmar con imagen
            firmarImage() {
                this.showFirmaImage.open = true
                //this.pages = this.handlePDF(this.file)
            },
            async handlePDF(pdfData) {

				let pages = []

				this.showFirmaImage.loading = true

				try {

					const loadingTask = pdfjsLib.getDocument({data: atob(pdfData)});

					this.pdf = await loadingTask.promise

					const scale = 4

					for(let i = 1; i <= this.pdf.numPages; i++) {

						let page = await this.pdf.getPage(i)
						const viewport = page.getViewport({scale})
			
						let canvas = document.getElementById(`canvas_${i}`)
						let canvasContext = canvas.getContext('2d')
						canvas.height = viewport.height
						canvas.width = viewport.width
						
						let renderTask = page.render({canvasContext, viewport})
						await renderTask.promise

						pages.push({
							page: i,
							data: canvas.toDataURL('image/jpeg'),
							cuadros: []
						})
					}

				} catch (err) {
					console.log(err)
					this.$notify.error({
						title: 'Error',
						message: 'Error al procesar el PDF'
					})
				}
		
				this.showFirmaImage.loading = false

				return pages
			},
            handleCommandFirmarAcciones(command) {
                this[command]()
            }
        }
	}
</script>

<style lang="scss">
.visor-pdf {
    display: flex;
    flex-grow: 1;
    flex-flow: column;

    .visor-pdf-content {
        flex-grow: 1;
        display: flex;
        flex-flow: column;

        .firmar {
            padding: 10px 15px;
            display: flex;
            align-items: center;
            flex-flow: column;
            flex-shrink: 0;
            align-items: end;
            @media(min-width: 768px) { 
                flex-flow: row;
                align-items: start;
            }

            > button {
                flex-shrink: 0;
                width: 100%;
                order: 3;
                @media(min-width: 768px) {
                    order: 0;
                    margin-bottom: 0px;
                    width: auto;
                }
                &:first-child {
                    margin-right: 5px;
                }
            }
            > .el-input {
                margin-right: 5px;
                margin-bottom: 5px;
                @media(min-width: 768px) { margin-bottom: 0px; }
            }
            > .el-button-group {
                flex-shrink: 0;
                margin-bottom: 5px;
                @media(min-width: 768px) { margin-bottom: 0px; }
            }
            .firmar-acciones {
                display: flex;
                width: 100%;
                margin-bottom: 5px;
                @media(min-width: 768px) { 
                    width: auto;
                    flex-shrink: 0;
                    margin-bottom: 0px;
                }
                button {
                    width: 50%;
                    @media(min-width: 768px) { 
                        flex-shrink: 0;
                        width: inherit;
                    }
                }
            }
        }
        .pdf-app .toolbar {
            z-index: 998!important;
        }
    }
}
   
// VISOR PDF FIRMA IMAGEN
.dialog-firma {
    > .el-dialog {
        margin-top: 50px!important;
        height: 90vh!important;
        display: flex;
        flex-flow: column;
        .el-dialog__body {
            display: flex;
            flex-grow: 1;
        }
        .el-dialog__footer {
            flex-shrink: 0;
        }
    }
}
</style>